module.exports = __webpack_public_path__ + "src/images/products/prep/34_Boucle-Striped T-Shirt.png";